import {
  CompoundButton,
  Text,
  makeStyles,
  tokens,
} from '@coreai/fluentui-react';
import {
  BotSparkleRegular,
  PlugConnectedRegular,
  ServerRegular,
} from '@fluentui/react-icons';
import type { ReactElement } from 'react';
import type { ConnectionCategory } from './addConnectionTypes';

const useStyles = makeStyles({
  intro: {
    color: tokens.colorNeutralForeground2,
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: tokens.spacingHorizontalM,
  },
  choice: {
    minHeight: '88px',
    height: 'auto',
    justifyContent: 'flex-start',
    padding: tokens.spacingVerticalM,
  },
});

const CATEGORY_CHOICES: readonly {
  category: ConnectionCategory;
  name: string;
  description: string;
  icon: ReactElement;
}[] = [
  {
    category: 'connectors',
    name: 'Connectors',
    description:
      'Connect to systems, services, and applications in the cloud or behind a VNET. Built-in connectors run on the same compute as the Logic Apps runtime.',
    icon: <PlugConnectedRegular fontSize={32} aria-hidden="true" />,
  },
  {
    category: 'agent',
    name: 'Agent or model',
    description: 'Connect an AI model or Foundry provider.',
    icon: <BotSparkleRegular fontSize={32} aria-hidden="true" />,
  },
  {
    category: 'mcp',
    name: 'MCP server',
    description: 'Register a custom Model Context Protocol server.',
    icon: <ServerRegular fontSize={32} aria-hidden="true" />,
  },
];

export interface ConnectionFamilyChooserProps {
  onSelect: (category: ConnectionCategory) => void;
}

export const ConnectionFamilyChooser = ({
  onSelect,
}: ConnectionFamilyChooserProps) => {
  const styles = useStyles();

  return (
    <>
      <Text className={styles.intro}>
        Choose the kind of connection to add to this application.
      </Text>
      <div className={styles.grid} role="group" aria-label="Connection types">
        {CATEGORY_CHOICES.map((choice) => (
          <CompoundButton
            key={choice.category}
            className={styles.choice}
            icon={choice.icon}
            secondaryContent={choice.description}
            onClick={() => onSelect(choice.category)}
          >
            {choice.name}
          </CompoundButton>
        ))}
      </div>
    </>
  );
};
